import { useEffect, useState } from "react";


interface UseCountDownProps {
  seconds: number;
  // startCounting: boolean;
}
export const useCountDown = ({ seconds }: UseCountDownProps) => {
  const [count, setCount] = useState(seconds);
  const [startCounting, setStartCounting] = useState(false);

  useEffect(() => {
    if (startCounting) {
      const interval = setInterval(() => {
        setCount(prevCount => {
          if (prevCount > 0) {
            return prevCount - 1;
          } else {
            clearInterval(interval);
            return 0;
          }
        });
      }, 1000);
    }
  }, [startCounting]);

  return { count, startCounting, setStartCounting };
};
